import { render, staticRenderFns } from "./VisitCreate.vue?vue&type=template&id=cc87ce3c&scoped=true"
import script from "./VisitCreate.vue?vue&type=script&lang=js"
export * from "./VisitCreate.vue?vue&type=script&lang=js"
import style0 from "./VisitCreate.vue?vue&type=style&index=0&id=cc87ce3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc87ce3c",
  null
  
)

export default component.exports